<template>
  <div class="container-table">
    <table class="silo-viz-table">
      <tr>
        <td>Silo</td>
        <td>{{ sensorName }}</td>
      </tr>
      <tr>
        <td>Data-hora</td>
        <td>{{ formattedDatetime }}</td>
      </tr>
      <tr>
        <td>Nivel</td>
        <td>{{ formattedLevel }}</td>
      </tr>
      <tr>
        <td>Volume</td>
        <td>{{ formattedVolume }}</td>
      </tr>
      <tr>
        <td>Peso</td>
        <td>{{ formattedWeight }}</td>
      </tr>
      <tr>
        <td>Sacas</td>
        <td>{{ formattedSacs }}</td>
      </tr>
      <tr>
        <td>Materia Prima</td>
        <td>{{ foodName }}</td>
      </tr>
      <tr>
        <td>Densidade</td>
        <td>{{ formattedDensity }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: "SiloProfileInfoTable",
  props: {
    sensorName: {
      type: String,
      default: ''
    },
    profileData: {
      type: Object,
      default: null
    },
    sacaWeight: {
      type: Number,
      default: 60
    },
    foodByCompany: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    formattedDatetime() {
      if (!this.profileData?.datetime_fetched) return '';
      return moment(this.profileData.datetime_fetched).format("DD/MM/YY - H:mm");
    },
    formattedLevel() {
      if (!this.profileData?.level) return '';
      const level = Number(this.profileData.level) || 0;
      return level < 0.1 ? '0%' : `${level.toFixed(2)}%`;
    },
    formattedVolume() {
      if (!this.profileData?.volume) return '';
      const level = Number(this.profileData.level) || 0;
      if (level < 0.1) return '0 m³';
      return `${this.formatNumberWithThousandSeparator(this.profileData.volume)} m³`;
    },
    formattedWeight() {
      if (!this.profileData?.weight) return '';
      const level = Number(this.profileData.level) || 0;
      if (level < 0.1) return '0 kg';
      return `${this.formatNumberWithThousandSeparator(this.profileData.weight)} kg`;
    },
    formattedSacs() {
      if (!this.profileData?.weight || !this.sacaWeight) return '';
      const level = Number(this.profileData.level) || 0;
      if (level < 0.1) return '0';
      const numberOfSacs = this.profileData.weight / this.sacaWeight;
      return this.formatNumberWithThousandSeparator(numberOfSacs);
    },
    foodName() {
      if (!this.profileData?.food || !this.foodByCompany) return '';
      const food = this.foodByCompany.find(f => f.pk === this.profileData.food);
      return food?.name || '';
    },
    formattedDensity() {
      if (!this.profileData?.food || !this.foodByCompany) return '';
      const food = this.foodByCompany.find(f => f.pk === this.profileData.food);
      if (!food?.density) return '';
      return `${food.density} kg/m³`;
    }
  },
  methods: {
    formatNumberWithThousandSeparator(n) {
      if (n === null || n === undefined || isNaN(n)) return '';
      return n.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>

<style scoped>
.container-table {
  display: flex;
  justify-content: center;
  max-width: 500px;
  width: 100%;
}

.silo-viz-table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}

.silo-viz-table td {
  border: 1px solid #ddd;
  padding: 5px 7px;
}

.silo-viz-table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.silo-viz-table tr:hover {
  background-color: #ddd;
}

.silo-viz-table td:first-child {
  font-weight: bold;
  background-color: #f8f9fa;
  width: 40%;
}
</style>

